module.exports = __webpack_public_path__ + "img/var_02_slippage.0f4aeeca.png";